import { memo, useRef, useState } from "react";
import * as PR from "../../prime-react/index";

const LeftPanel = memo(({
  isAnalyst,
  filteredGroups,
  groupSearchInput,
  onGroupSearchChange,
  groupHandler,
  regulatorChangeHandler,
  conversationIds,
  groupInitials,
  sortOrder,
  setSortOrder,
  unreadFirst,
  setUnreadFirst,
}) => {
  const sortMenu = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isAnalyst) return null;

  const sortItems = [
    {
      label: 'Sort Alphabetically',
      items: [
        {
          label: 'A to Z',
          icon: sortOrder === 'az' ? 'pi pi-check' : 'pi pi-fw',
          command: () => setSortOrder('az')
        },
        {
          label: 'Z to A',
          icon: sortOrder === 'za' ? 'pi pi-check' : 'pi pi-fw',
          command: () => setSortOrder('za')
        },
        {
          label: 'Default',
          icon: sortOrder === 'default' ? 'pi pi-check' : 'pi pi-fw',
          command: () => setSortOrder('default')
        }
      ]
    },
    {
      label: 'Preferences',
      items: [
        {
          label: 'Unread First',
          icon: unreadFirst ? 'pi pi-check' : 'pi pi-fw',
          command: () => setUnreadFirst(prev => !prev)
        }
      ]
    }
  ];

  const visibleGroups = isExpanded ? filteredGroups : filteredGroups.slice(0,10);

  return (
    <aside className="chat-sidebar regulators-panel">
      <div className="panel-heading">
        <h2>Regulators & Governing Bodies</h2>
      </div>
      <div className="search-sort-container">
        <div className="chat-search">
          <PR.InputText
            type="text"
            placeholder="Search regulators & governing bodies..."
            value={groupSearchInput}
            onChange={onGroupSearchChange}
          />
          <i className="pi pi-search" />
        </div>
        <button
          type="button"
          className={`chat-sort-btn ${sortOrder !== "default" || unreadFirst ? "active" : ""}`}
          onClick={(e) => sortMenu.current.toggle(e)}
          aria-label="Sort regulators"
          aria-controls="regulators_sort_menu"
          aria-haspopup
        >
          <i className="pi pi-sliders-h" />
        </button>
        <PR.Menu model={sortItems} popup ref={sortMenu} id="regulators_sort_menu" className="sort_menu" />
      </div>
      <div className="sidebar-list">
        {visibleGroups.map((group, index) => (
          <button
            type="button"
            key={group.id}
            className={`sidebar-item ${conversationIds.groupID === group.id ? "active" : ""}`}
            onClick={() =>
              group.hasExistingThread
                ? groupHandler({ value: group.id })
                : regulatorChangeHandler({ id: group.id, name: group.name })
            }
          >
            <span className={`sidebar-avatar avatar-color-${index % 10}`}>{groupInitials(group.name)}</span>
            <span className="sidebar-copy">
              <span className="sidebar-title">{group.name}</span>
            </span>
            <span className="sidebar-count">
              {group.unreadConversationCount || ""}
              {conversationIds.groupID === group.id && (
                <i className="pi pi-chevron-right active-chevron" />
              )}
            </span>
          </button>
        ))}
        {filteredGroups.length > 10 && (
          <div className="view-more-container">
            <button
              type="button"
              className="view-more-btn"
              onClick={() => setIsExpanded(prev => !prev)}
            >
              {isExpanded ? (
                <>
                  View less <i className="pi pi-chevron-up ml-1" />
                </>
              ) : (
                <>
                  View more <i className="pi pi-chevron-down ml-1" />
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </aside>
  );
});

export default LeftPanel;
